import React from 'react';

import { Box } from '@rbilabs/universal-components';

import { Upsell } from 'pages/cart/upsell';

const UpsellCarouselWrapper = Box.withConfig({
  marginX: '$4',
});

export const ProductUpsell: React.FC = () => (
  <UpsellCarouselWrapper>
    <Upsell />
  </UpsellCarouselWrapper>
);
